import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
export default {
  props: {
    value: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    maxSize: {
      type: Number,
      default: 0
    },
    serialize: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 60
    },
    limit: {
      type: Number,
      default: 6
    },
    hint: {
      type: String,
      default: ''
    },
    toast: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      percentage: 0,
      isShow: false,
      colors: [{
        color: '#f56c6c',
        percentage: 25
      }, {
        color: '#e6a23c',
        percentage: 50
      }, {
        color: '#1989fa',
        percentage: 75
      }, {
        color: '#5cb87a',
        percentage: 100
      }],
      fileList: [],
      img: '',
      timer: null
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (!this.serialize) {
          this.fileList = val || [];
        } else {
          this.fileList = val ? val.split(',') : [];
        }
      },
      immediate: true
    },
    fileList: function fileList(val) {
      if (!this.serialize) {
        this.$emit('input', val);
      } else {
        this.$emit('input', val.length ? val.join(',') : '');
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    delItem: function delItem(row) {
      if (this.fileList.length == 1) {
        this.fileList = [];
      } else {
        this.fileList = this.fileList.filter(function (item) {
          return item != row;
        });
      }
    },
    onClick: function onClick() {
      if (this.disabled) return;
      this.$refs.input.click();
    },
    sendForm: function sendForm(file) {
      var _this = this;
      this.file = file;
      this.isShow = true;
      var formData = new FormData();
      formData.append('file', file);
      this.$axios({
        url: '/bbb/fileUpload/local',
        method: 'post',
        data: formData,
        onUploadProgress: function onUploadProgress(res) {
          _this.percentage = Number(Math.floor(res.loaded / res.total * 100).toFixed(0));
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        if (res.code == 200) {
          _this.$refs.input.value = null;
          clearTimeout(_this.timer);
          _this.timer = setTimeout(function () {
            _this.resetData('isShow,percentage,img');
            _this.fileList.push(res.data);
          }, 500);
        } else {
          _this.$refs.input.value = null;
          _this.resetData('isShow,percentage,img');
        }
      }).catch(function () {
        _this.$refs.input.value = null;
        _this.resetData('isShow,percentage,img');
      });
    },
    onChange: function onChange(e) {
      var _this2 = this;
      if (this.accept) {
        if (this.accept === 'image/*') {
          this.accept = 'image/jpeg,image/png,image/jpg,image/webp';
        }
        if (e.target.files[0].type == 'image/webp' || this.accept.indexOf(e.target.files[0].type.split('/')[1]) == -1) {
          this.$refs.input.value = null;
          return this.$message.warning(this.toast || '请选择合法文件');
        }
        if (this.accept.indexOf(e.target.files[0].type) == -1 && this.accept != 'image/*') {
          this.$refs.input.value = null;
          return this.$message.warning("\u4EC5\u4EC5\u652F\u6301".concat(this.accept, "\u7C7B\u578B\u7684\u56FE\u7247\u4E0A\u4F20"));
        }
      }
      if (this.maxSize && e.target.files[0].size / 1024 > this.maxSize) {
        this.$refs.input.value = null;
        return this.$message.warning("\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat((this.maxSize / 1024).toFixed(2), "M"));
      }
      if (e.target.files[0].type.indexOf('image') != -1) {
        this.blobToDataURL(e.target.files[0], function (base64Url) {
          _this2.img = base64Url;
          _this2.sendForm(e.target.files[0]);
        });
      } else {
        this.img = 'wenjian.png';
        this.sendForm(e.target.files[0]);
      }
    },
    blobToDataURL: function blobToDataURL(blob, cb) {
      var reader = new FileReader();
      reader.onload = function (evt) {
        var base64 = evt.target.result;
        cb(base64);
      };
      reader.readAsDataURL(blob);
    }
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
  }
};